import { useEffect } from "react";
import Shop from "@/pages/Shop";

/**
 * Hidden `/kms/shop` route — renders the normal Shop with KMS-exclusive
 * products surfaced at the top. Everything else — bundles, regular
 * products, checkout, cart, Printful fulfillment, order DB, analytics —
 * flows through the same code paths as /shop.
 */
export default function KmsShop() {
  useEffect(() => {
    try {
      window.sessionStorage.setItem("kms_access", "1");
    } catch { /* private mode */ }
  }, []);
  return <Shop kmsMode />;
}
